import { MasonryCTACardRenderer } from '@leagueplatform/masonry-renderers';

export const ConsultationCtaCard: typeof MasonryCTACardRenderer = (props) => (
  <MasonryCTACardRenderer
    {...props}
    css={{
      padding: '$oneAndHalf',
      '.GDS-button': {
        marginTop: '$none',
      },
      '@mobile': {
        '.GDS-button': {
          marginTop: '$one',
        },
      },
    }}
  />
);
